import {
  Characters,
  ItemName,
  Locale,
  WithExclusion,
  type WithExclusionObject,
} from '@ps-smart-cp/ppfw-client';

interface Schema {
  /**
   * セグメントマスタキー
   */
  segmentMstKey: number;
  /**
   * 上位セグメントコード
   */
  higherRankSegmentCode: string;
  /**
   * セグメントマスタコード
   */
  segmentMstCode: string;
  /**
   * セグメントマスタコード(抽出条件)
   */
  segmentMstCodeRange: WithExclusionObject;
  /**
   * セグメントキー
   */
  key: number;
  /**
   * セグメント(表示用)
   */
  segment: string;
  /**
   * セグメント(抽出条件)
   */
  segmentCondition: WithExclusionObject;
  /**
   * セグメント名称
   */
  // TODO https://proship-tech.atlassian.net/browse/PPBOS-4894 マスタ項目のネーミングはmst付ける付けないを統一対応
  segmentMstName: string;
}

interface R {
  segmentMstKey: number;
  higherRankSegmentCode: string;
  segmentMstCode: string;
  segmentMstCodeRange: string;
  isSegmentMstCodeRangeExcluded: boolean;
  key: number;
  segment: string;
  segmentRange: string;
  isSegmentRangeExclusion: boolean;
  // TODO https://proship-tech.atlassian.net/browse/PPBOS-4894 マスタ項目のネーミングはmst付ける付けないを統一対応
  segmentMstName: string;
  segmentCodes: Record<string, string>;
}

const attributes = {
  segmentCondition: WithExclusion.of(Characters.preset.halfWidth()),
};

const names = {
  higherRankSegmentCode: ItemName.of([Locale.ja, '上位セグメント'], [Locale.en, 'Higher Rank Segment']),
  segment: ItemName.of([Locale.ja, 'セグメント']),
  segment01: ItemName.of([Locale.ja, 'セグメント01']),
  segment02: ItemName.of([Locale.ja, 'セグメント02']),
  segment03: ItemName.of([Locale.ja, 'セグメント03']),
  segment04: ItemName.of([Locale.ja, 'セグメント04']),
  segment05: ItemName.of([Locale.ja, 'セグメント05']),
};

interface SegmentMst {
  schema: Schema;
  record: R;
}

export const segmentMst = {
  attributes,
  names,
};

export type { SegmentMst };
